import { Okul } from 'gql/StaticTypes'
import React from 'react'
import { AuthState } from 'utils/types'
export interface GlobalNotificationType {
  type: 'success' | 'info' | 'warning' | 'error'
  message: string
  description?: string
}
export interface AppContextType {
  slug: string | null
  authState: AuthState
  setAuthState: (authState: AuthState) => void
  setToken: (token: string) => void
  setEmail: (token: string) => void
  setSinif?: (sinif: number) => void
  setCiro?: (sinif: boolean) => void
  setSiparisYetki?: (sinif: boolean) => void
  okul: Okul | null
  token: string
  email: string
  sinif?: number
  ciro?: boolean
  siparisYetki?: boolean
  globalNotification?: GlobalNotificationType | null
  setGlobalNotification: (notification: GlobalNotificationType | null) => void
}

const AppContext = React.createContext<AppContextType>({
  authState: AuthState.LOGGED_OUT,
  setAuthState: () => {},
  slug: '',
  setToken: () => {},
  setEmail: () => {},
  setSinif: () => {},
  setGlobalNotification: () => {},
  okul: null,
  token: '',
  email: '',
  globalNotification: null, // Varsayılan değer null olmalı
  sinif: 0
})

export default AppContext
